import { Feather, Ionicons } from "@expo/vector-icons";
import React from "react";
import { View } from "react-native";
import { rsvpTone, RsvpTone } from "../theme";

export type RsvpIconName =
  | "check"
  | "clock"
  | "hourglass"
  | "bell"
  | "ban"
  | "alert-circle"
  | "wifi-off"
  | "user-x";

interface Props {
  name: RsvpIconName;
  tone: RsvpTone;
  size?: number;
}

/** Tinted circular icon badge used by the status/error states. */
const RsvpStatusIcon: React.FC<Props> = ({ name, tone, size = 64 }) => {
  const { color, iconBg } = rsvpTone[tone];
  const iconSize = Math.round(size / 2);

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: iconBg,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {name === "hourglass" ? (
        <Ionicons name="hourglass-outline" size={iconSize} color={color} />
      ) : (
        <Feather
          name={name === "ban" ? "slash" : name}
          size={iconSize}
          color={color}
        />
      )}
    </View>
  );
};

export default RsvpStatusIcon;
